// extracted by mini-css-extract-plugin
export default {"main__wrapper":"FeaturedCollabs_main__wrapper__ah7vC"};